import * as Sentry from "@sentry/react-router";
import { startTransition, StrictMode } from "react";
import { hydrateRoot } from "react-dom/client";
import { HydratedRouter } from "react-router/dom";
import { redactMailTokensInBreadcrumb, redactMailTokensInSentryEvent } from "@/lib/mail-token-url";

// 本番として扱うホスト。yumesaku.tech を入れ忘れていたせいで、
// /women へ移した後の本番エラーが Sentry に一切上がっていなかった
// (決済 API が丸ごと 404 になっていたのも、これで誰にも見えなかった)
const IS_PRODUCTION_HOST = ["luagate.com", "yumesaku.tech"].includes(
  window.location.hostname,
);

// Sentry 初期化 (本番のみ)
Sentry.init({
  dsn: "https://b43304b92e09078d2d16a4abf5449326@o4508291417702400.ingest.us.sentry.io/4511566983987200",
  environment: IS_PRODUCTION_HOST ? "production" : "development",
  enabled: IS_PRODUCTION_HOST,
  // Performance Monitoring を低サンプリングで有効化 (無料枠を圧迫しないよう)
  tracesSampleRate: 0.05,
  // React Router v7 と統合してナビゲーション情報を取得
  integrations: [Sentry.reactRouterTracingIntegration()],
  // ブラウザ拡張機能等から来る不要なエラーをフィルタ
  ignoreErrors: [
    "ResizeObserver loop limit exceeded",
    "ResizeObserver loop completed with undelivered notifications",
    "Non-Error promise rejection captured",
  ],
  // 停止と同意の確認のページの住所の ?t= (メールの印) を送らない
  beforeSend: (event) => redactMailTokensInSentryEvent(event),
  beforeSendTransaction: (event) => redactMailTokensInSentryEvent(event),
  beforeBreadcrumb: (crumb) => redactMailTokensInBreadcrumb(crumb),
});

startTransition(() => {
  hydrateRoot(
    document,
    <StrictMode>
      <HydratedRouter />
    </StrictMode>
  );
});
